
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-product-acceleration/assessment",
      function () {
        return require("private-next-pages/ai-product-acceleration/assessment.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-product-acceleration/assessment"])
      });
    }
  